'use strict';

const filterParentModel = require('od-modules/models/accommodation_filter');

module.exports = Odigeo.Model.extend(filterParentModel).extend({
    filterMetadataPath: 'accommodationFiltersMetadata.priceMetadata',

    defaults: {
        selectedMinPrice: 0,
        selectedMaxPrice: 10,
        minPercentile: 0,
        maxPercentile: 10,
        average: 5,
        relativeFrequencies: [],
    },

    updateFilterStatus(ev, newFilterStatus, isResetRequested) {
        ev.stopPropagation();
        this.resetModel(isResetRequested);
        this.set(Odigeo._.extend(
            this.round((Odigeo._.get(newFilterStatus, this.filterMetadataPath))),
            {isResetRequested}
        ));
    },

    round: function(obj) {
        return Odigeo._.reduce(Odigeo._.pick(obj, Odigeo._.keys(this.defaults)), function(memo, value, key) {
            memo[key] = Odigeo._.isNumber(value) ? +value.toFixed(0) : value;
            return memo;
        }, {});
    },
});
